import Prng from '@delight-im/prng'
import * as data from 'data'

class Recipe {
  constructor (seed) {
    this.prng = new Prng(seed)
    this.recipeObj = {
      ingredients: this.fetchIngredients()
    }
    this.generateRecipe(this.recipeObj)
  }
  getRandomInt (min = 0, max) {
    return this.prng.getRandomInt(min, max)
  }

  getRandom () {
    return this.prng.getRandom()
  }

  capitalize ([first, ...rest], lowerRest = false) {
    return first.toUpperCase() + (lowerRest ? rest.join('').toLowerCase() : rest.join(''))
  }

  sample (arr) {
    return arr[Math.floor(this.getRandom() * arr.length)]
  }

  sampleSize ([...arr], n = 1) {
    let m = arr.length
    while (m) {
      const i = Math.floor(this.getRandom() * m--);
      [arr[m], arr[i]] = [arr[i], arr[m]]
    }
    return arr.slice(0, n)
  }

  fetchIngredients () {
    return this.sampleSize(data.ingredients, 8)
  }
  generateRecipe (obj) {
    const prep = this.sampleSize(data.prepare, 8)
    const prepResult = this.sampleSize(data.prepResults, 8)

    obj.ingredients.forEach((ingredient, index) => {
      const unit = this.sample(data.units)
      ingredient.amount = `${this.getRandomInt(unit.min, unit.max)} ${unit.unit}`
      ingredient.prep = prep[index]
      ingredient.prepResult = prepResult[index]
    })

    obj.prepped = obj.ingredients.map(ingredient => {
      const prepped = {}
      prepped.name = ingredient.name + ingredient.prepResult.article
      prepped.part = ingredient.name
      return prepped
    })

    const cook = this.sampleSize(data.cook, 3)
    const prepped = this.sampleSize(obj.prepped, 3)
    const cookResults = this.sampleSize(data.cookResults, 3)

    obj.cook = cook.map((action, index) => {
      return `${action.action} ${prepped[index].name} ${cookResults[index]}`
    })

    obj.serve = this.sample(data.serve)

    const titleIngredients = this.sampleSize(obj.ingredients, 3)

    obj.title = `${this.sample(cookResults)} ${this.sample(cook).result}
     ${titleIngredients[0].name}${titleIngredients[1].name}
     ${obj.serve} ${titleIngredients[2].name}`

    obj.title = this.capitalize(obj.title)

    return obj
  }

  getIngredients () {
    return this.recipeObj.ingredients.map(i => `${i.amount} ${i.name}`)
  }

  getPrepInstructions () {
    const { ingredients } = this.recipeObj
    return ingredients.reduce((prev, curr) => {
      return prev + ` ${this.capitalize(curr.prep)} ${curr.name} till ${curr.prepResult.result}. `
    }, '')
  }

  getCookInstructions () {
    const { cook } = this.recipeObj
    return cook.reduce((prev, curr) => {
      return prev + ` ${this.capitalize(curr)}. `
    }, '')
  }

  getServeInstructions () {
    return `Servera ${this.recipeObj.title}`
  }
}

export default Recipe



// WEBPACK FOOTER //
// ./src/Recipe/index.js